import React, { Fragment, useRef, useState } from "react";
import { isMobile } from "react-device-detect";

import ConditionWrapper from "components/ConditionWrapper";
import VodThumb from "components/boards/post/vod/VodThumb";
import VodInfo from "components/boards/post/vod/VodInfo";
import PostMoreButton from "components/boards/post/PostMoreButton";

import { useSelector, useDispatch } from "react-redux";
import PostHomePin from "../PostHomePin";

const VodItem = ({
    vod = {},
    authority = {},
    inflowPath,
    thumbHeight,
    moreButtonTop,
    isPpvBj,
    loading = false,
    pageType,
    onDestroyPin = () => {},
    location = 'vods',
    catchCreated = true,
    pageCreated = false
}) => {
    const [laterButtonClick, setLaterButtonClick] = useState(false);
    const dispatch = useDispatch();
    const triggerButtonRef = useRef(null);

    const { laterButtonOpen } = useSelector(({ homeIctMenuReducer }) => ({
        laterButtonOpen: homeIctMenuReducer.laterButtonOpen
    }));

    const handleOpenLaterButton = (event) => {
        event.stopPropagation();

        if (laterButtonClick && laterButtonOpen) {
            dispatch({type: "ICT_CLOSE_MODAL"});
            dispatch({type: "LATER_CLOSE_MODAL"});
            setLaterButtonClick(false);
            return;
        }

        dispatch({type: "ICT_CLOSE_MODAL"});
        dispatch({type: "LATER_CLOSE_MODAL"});

        if (event && event.target) {
            const {top, left} = event.target.getBoundingClientRect();
            let newTop = top + window.scrollY;
            let newLeft = left + window.scrollX;
            setLaterButtonClick(true);
            dispatch({type: "LATER_OPEN_MODAL",
                payload:{
                    titleNo: vod?.title_no,
                    top: (newTop + 25),
                    left: newLeft - 170,
                }})
        }
    }

    if (loading) {
        return (
            <>
                {!isMobile && (
                    <div className="ld-grid-row-2">
                        <div>
                            <span />
                        </div>
                        <div className="list">
                            <span />
                            <span />
                        </div>
                    </div>
                )}

                {isMobile && (
                    window.location.href.includes('catch') ? 
                        <div className="grid"></div>
                    : 
                    <div className="ld-grid-col-2">
                        <div>
                            <div>
                                <span />
                            </div>
                        </div>
                        <div className="ld-grid-row-2">
                            <div>
                                <span />
                            </div>
                            <div>
                                <span />
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }

    return (
        <Fragment>
            {/* vod 썸네일 노출 */}
            <ConditionWrapper condition={isMobile} wrapper={<div className="list_wrap"></div>}> 
                <>
                    <VodThumb
                        inflowPath={inflowPath}
                        vod={vod}
                        isPpvBj={isPpvBj}
                        height={thumbHeight}
                        pageType={pageType}
                        onDestroyPin={onDestroyPin}
                        authority={authority}
                        location={location}
                        catchCreated={catchCreated}
                        pageCreated={pageCreated}
                    />
                    {/* vod 정보 노출 */}
                    <VodInfo inflowPath={inflowPath} vod={vod} authority={authority} location={location}/>
                </>
            </ConditionWrapper>
            {/* vod 컨트롤 버튼 (3dot) */}
            {isMobile && (
                <PostHomePin post={vod} authority={authority} location={location} created={pageCreated} />
            )}
            {location !== 'home' && <PostMoreButton post={vod} authority={authority} top={moreButtonTop} right={0} pageCreated={pageCreated} />}
            {location === 'home' && vod?.ucc?.file_type !== 'CATCH' && (
                <button type="button" ref={triggerButtonRef} className="btn-detail" onClick={handleOpenLaterButton}>
                    <span>상세정보</span>
                </button>
            )}
        </Fragment>
    );
};

export default VodItem;
